
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grocery/supermarket-pos-billing-software",
      function () {
        return require("private-next-pages/grocery/supermarket-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grocery/supermarket-pos-billing-software"])
      });
    }
  